import { ReactComponent as Loading } from '../../../assets/spinner.svg';

export function GroupBuildProgress(props: { progress: number | undefined }) {
    return <div className="flex flex-row justify-end">
        <div className="flex flex-col items-center justify-center gap-y-1">
            <Loading />
            <p className="p-0 m-0 text-sm">{props.progress ?? 0}%</p>
        </div>
    </div>;
}